var map = {
	"./android/translation": "7e93",
	"./applications/translation": "ToQN",
	"./betgamesnew/translation": "F/eK",
	"./bonus15k/translation": "aWqV",
	"./bonus20k/translation": "/86g",
	"./bonus30or35/translation": "xHNX",
	"./broadcast/translation": "ggpA",
	"./championseries/translation": "gLQE",
	"./cybersport/translation": "GRIs",
	"./football_bet/translation": "NXe+",
	"./formula1/translation": "m34A",
	"./freebet30or35/translation": "1ZTe",
	"./freebet5000/translation": "qRJZ",
	"./freebet_for_app/translation": "8OtZ",
	"./freexpress/translation": "i18L",
	"./happy_hockey/translation": "k6lZ",
	"./happysport/translation": "Ez1u",
	"./lucky_xpress/translation": "TRMY",
	"./luckyzero/translation": "ycf/",
	"./moneybox/translation": "hRZU",
	"./ny_moneybox/translation": "iAPC",
	"./olympics/translation": "dJd4",
	"./people/translation": "PDRf",
	"./prediction_battle/translation": "/Zwq",
	"./products/translation": "AKcx",
	"./registrationForm/translation": "PvAM",
	"./slotMachine/translation": "z3oH",
	"./spinMachine/translation": "t5AW",
	"./sportbonus/translation": "AcNM",
	"./start15or20/translation": "6sug",
	"./superdep/translation": "L8ww",
	"./templateElements/translation": "YOzu",
	"./tennis_us/translation": "Dm58",
	"./tournamentCasino/all_stars/translation": "gY/+",
	"./tournamentCasino/fridayCash/translation": "uNgw",
	"./tournamentCasino/richy_rabbit/translation": "qaS5",
	"./tournamentCasino/spin_mania/translation": "PBp+",
	"./welcome_bonus_casino/translation": "RHUn",
	"./welcome_bonus_casino_ny22/translation": "O+89",
	"./welcome_bonus_ny22/translation": "RZ2r",
	"./withoutOffer/translation": "OcJX"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "m/+L";